import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

export const UndecoratedLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;
